module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_8019.9d231684.png";